import React from 'react'
import {Label } from 'semantic-ui-react'
import { connect } from 'react-redux'

class TimedLabel extends Label {
    constructor(props) {
        super(props)
        this.state = {
            startTime: 0,
            time:this.props.type==='bet'?this.props.betMs:this.props.answerMs,
            remainingTime: this.props.type==='bet'?this.props.betMs:this.props.answerMs,
            intervalId: 0,
            isProgress: false,
            enabled:false
        }
    }

    start = () =>{
        this.setState({ startTime: Date.now(), intervalId: setInterval(this.tick, 100), isProgress:true})
    }

    componentDidUpdate(prevProps) {
        if (this.state.remainingTime > 0)
            if (this.props !== prevProps){
                if (this.props.enabled !== this.state.enabled) {
                        this.setState({enabled:this.props.enabled})
                }
                this.setState({time:this.props.type==='bet'?this.props.betMs:this.props.answerMs, 
                            remainingTime: this.props.type==='bet'?this.props.betMs:this.props.answerMs})
            }
      }


    componentWillUnmount() {
        const { intervalId } = this.state
        if (intervalId)
            clearInterval(intervalId)
        this.setState({enabled:false})
    }

    tick = () => {
        const { time} = this.state
        const elapsedTime = Date.now() - this.state.startTime
        const remainingTime = time - elapsedTime
        if (remainingTime > 0) {
            this.setState({ remainingTime:remainingTime})
        } else {
            clearInterval(this.state.intervalId)
            this.setState({ remainingTime: 0, intervalId:0})
            this.setState({isProgress:false, enabled:false})
        }
    }

    render() {
        const { remainingTime, isProgress,enabled } = this.state
        if (enabled){
            if (isProgress){
                return (<Label style={{backgroundColor: 'transparent',  color:'white', fontSize: '13px'}}>
                {(remainingTime / 1000).toFixed(1)}
                </Label>)
            } else{
                this.start();
                return null;
            }
        }
        return null;
    }
}


const mapStateToProps = (state) => ({
    betMs: state.betMs,
    answerMs: state.answerMs
})

const mapDispatchToProps = (dispatch) => ({
})


export default connect(
    mapStateToProps, 
    mapDispatchToProps
)(TimedLabel)



// WEBPACK FOOTER //
// ./src/components/TimedLabel.js